export default "__VITE_ASSET__DowCDWot__"